import React, { useEffect, useState } from "react";
import {
  SimpleItem, GroupItem, TabbedItem, TabPanelOptions, Tab, Label, RequiredRule, ButtonItem, ButtonOptions
} from 'devextreme-react/form';
import ComboAbmArtArticulos from "../Compuestos/Combos/ComboAbmArtArticulos";
import ComboAbmConCuentasContable from "../Compuestos/Combos/ComboAbmConCuentasContables";
import ComboAbmConSubCentrosCosto from "../Compuestos/Combos/ComboAbmConSubCentrosCosto";
import ComboAbmArtSubTiposCompra from "../Compuestos/Combos/ComboAbmArtSubTiposCompra";
import ComboAbmArtSubTiposVenta from "../Compuestos/Combos/ComboAbmArtSubTiposVenta";
import ComboAbmArtTamanos from "../Compuestos/Combos/ComboAbmArtTamanos";
import ComboAbmArtPresentaciones from "../Compuestos/Combos/ComboAbmArtPresentaciones";
import ComboAbmArtUnidadesMedida from "../Compuestos/Combos/ComboAbmArtUnidadesMedida";
import ComboAbmZonPlantas from "../Compuestos/Combos/ComboAbmZonPlantas";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { LVGridCarga } from "../Basicos/LVGridCarga";
import { LVForm } from "../Basicos/LVForm";
import { function_ABM_ART_Articulos_Generar_JSON, function_ABM_ART_Articulos_Insertar, function_ABM_ART_Articulos_Leer, function_ABM_ART_Articulos_Modificar } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos";
import { Column } from "devextreme-react/data-grid";
import { CheckBox, TextBox } from "devextreme-react";
import { function_ABM_ART_UnidadesMedida_Leer } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_UnidadesMedida";

const ABM_ART_Articulos = (props) => {
  const [valorCodigoSubtipoCompras, setValorCodigoSubtipoCompras] = useState(null);
  const [valorCodigoSubtipoVentas, setValorCodigoSubtipoVentas] = useState(null);
  const [valorCodigoSubCCVenta, setValorCodigoSubCCVenta] = useState(null);
  const [valorCodigoSubCCCompra, setValorCodigoSubCCCompra] = useState(null);
  const [valorCodigoCuentaContableVenta, setValorCodigoCuentaContableVenta] = useState(null);
  const [valorCodigoCuentaContableCompra, setValorCodigoCuentaContableCompra] = useState(null);
  const [valorCodigoArticuloConsumeStockDeOtroArticulo, setValorCodigoArticuloConsumeStockDeOtroArticulo] = useState(null);
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [esMultiEmpresa, setEsMultiEmpresa] = useState(true);
  const [esMultiPlanta, setEsMultiPlanta] = useState(true);

  const [presentacionSeleccionada, setPresentacionSeleccionada] = useState(null);
  const [tamanoSeleccionado, setTamanoSeleccionado] = useState(null);
  const [UnidadMedidaSeleccionada, setUnidadMedidaSeleccionada] = useState(null);
  const [esDivisible, setEsDivisible] = useState(false);
  const [esSoloParaVentas, setEsSoloParaVentas] = useState(false);
  const [esSoloParaCompras, setEsSoloParaCompras] = useState(false);
  const [factorDeConversion, setFactorDeConversion] = useState(1);
  const [plantaSeleccionada, setPlantaSeleccionada] = useState(null);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [codigoUnidadMedidaMinima, setCodigoUnidadMedidaMinima] = useState("");

  const handleOnValueChangedComprable = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      Comprable: isChecked,
    }));
  };

  const handleOnValueChangedVendible = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      Vendible: isChecked,
    }));
  };

  const handleOnValueChangedBajaStockEnRemito = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      BajaStockEnRemito: isChecked,
    }));
  };

  const handleOnValueChangedSubeStockEnRecepcion = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      SubeStockEnRecepcion: isChecked,
    }));
  };

  const handleOnValueChangedFabricable = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      Fabricable: isChecked,
    }));
  };

  const handleOnValueChangedReservable = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      Reservable: isChecked,
    }));
  };

  const handleOnValueChangedAgrupador = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      Agrupador: isChecked,
    }));
  };

  const handleOnValueChangedFantasma = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      Fantasma: isChecked,
    }));
  };

  const handleOnValueChangedOferta = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      Oferta: isChecked,
    }));
  };

  const handleOnValueChangedSeriado = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      Seriado: isChecked,
    }));
  };

  const handleOnValueChangedSeriadoObligatorio = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      SeriadoObligatorio: isChecked,
    }));
  };

  const handleOnValueChangedImporteSugeridoDeVentaEsImporteFinal = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      SeriadoObligatorio: isChecked,
    }));
  };

  const handleOnValueChangedImporteSugeridoDeVentaNoSeActualizaAutomaticamente = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      SeriadoObligatorio: isChecked,
    }));
  };

  const handleOnValueChangedServicio = (e) => {
    const isChecked = e.value;

    if (isChecked) {
      setDatos((prevDatos) => ({
        ...prevDatos,
        Stockeable: false,
        Servicio: true
      }));
    } else {
      setDatos((prevDatos) => ({
        ...prevDatos,
        Servicio: false,
      }));
    }
  };

  const handleOnValueChangedMultiEmpresa = (e) => {
    const isChecked = e.value;

    setEsMultiEmpresa(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiEmpresa: isChecked
    }));
  };

  const handleOnValueChangedMultiPlanta = (e) => {
    const isChecked = e.value;

    setEsMultiPlanta(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiPlanta: isChecked
    }));
  };

  const handleOnValueChangedStockeable = (e) => {
    const isChecked = e.value;

    if (isChecked) {
      setDatos((prevDatos) => ({
        ...prevDatos,
        Servicio: false,
        Stockeable: true
      }));
    } else {
      setDatos((prevDatos) => ({
        ...prevDatos,
        Stockeable: false,
      }));
    }
  };

  const handleOnValueChangedCodigoSubtipoCompras = (e) => {
    setValorCodigoSubtipoCompras(e.value)
    datos.CodigoSubtipoCompras = e.value;
  }

  const onValueChangedCodigoSubtipoVentas = (e) => {
    setValorCodigoSubtipoVentas(e.value)
    datos.CodigoSubtipoVentas = e.value;
  }

  const onValueChangedCodigoSubCentroCostoCompras = (e) => {
    setValorCodigoSubCCCompra(e.value)
    datos.CodigoSubCentroCostoCompras = e.value;
  }

  const onValueChangedCodigoSubCentroCostoVentas = (e) => {
    setValorCodigoSubCCVenta(e.value)
    datos.CodigoSubCentroCostoVentas = e.value;
  }

  const onValueChangedCodigoCuentaContableCompras = (e) => {
    setValorCodigoCuentaContableCompra(e.value)
    datos.CodigoCuentaContableCompra = e.value;
  }

  const onValueChangedCodigoCuentaContableVentas = (e) => {
    setValorCodigoCuentaContableVenta(e.value)
    datos.CodigoCuentaContableVenta = e.value;
  }

  const onValueChangedCodigoArticuloConsumeStockDeOtroArticulo = (e) => {
    setValorCodigoArticuloConsumeStockDeOtroArticulo(e.value)
    datos.CodigoArticuloConsumeStockDeOtroArticulo = e.value;
  }

  const handleOnValueChangedConsumeStockDeOtroArticulo = (e) => {
    const isChecked = e.value;
    setDatos((prevDatos) => ({
      ...prevDatos,
      ConsumeStockDeOtroArticulo: isChecked,
    }));
  };

  const handleOnClick_AgregarPresentacion = async (e) => {
    if (!presentacionSeleccionada.codigo) {
      alert("Seleccione una Presentación antes de agregar.");
      return;
    }

    // Verificar si la presentación ya está en la lista
    const presentacionYaExiste = datos.ListArticulosPresentaciones?.some(
      (presentacion) => presentacion.ABM_ART_Presentaciones_CodigoPresentacion === presentacionSeleccionada.codigo
    );

    if (presentacionYaExiste) {
      alert("La presentación ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto de presentación
    const nuevaPresentacion = {
      ABM_ART_Presentaciones_CodigoPresentacion: presentacionSeleccionada.codigo,
      CodigoPresentacion: presentacionSeleccionada.codigo,
      Descripcion: presentacionSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar la nueva presentación al estado
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListArticulosPresentaciones: [...(prevDatos.ListArticulosPresentaciones || []), nuevaPresentacion],
    }));

    // Limpiar la selección después de agregar
    setPresentacionSeleccionada(null);
  }

  const handleOnClick_AgregarTamano = async (e) => {
    if (!tamanoSeleccionado.codigo) {
      alert("Seleccione un Tamaño antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const tamanoYaExiste = datos.ListArticulosTamanos?.some(
      (tamano) => tamano.CodigoTamano === tamanoSeleccionado.codigo
    );

    if (tamanoYaExiste) {
      alert("El Tamaño ya ha sido agregado.");
      return;
    }

    // Crear el nuevo objeto
    const nuevoTamano = {
      CodigoTamano: tamanoSeleccionado.codigo,
      ABM_ART_Tamanos_CodigoTamano: tamanoSeleccionado.codigo,
      Descripcion: tamanoSeleccionado.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListArticulosTamanos: [...(prevDatos.ListArticulosTamanos || []), nuevoTamano],
    }));

    // Limpiar la selección después de agregar
    setTamanoSeleccionado(null);
  }

  const handleOnValueChanged_UnidadMedida = async (e) => {
    const descripcion = e.component?.option("text") || "";
    setUnidadMedidaSeleccionada({
      codigo: e.value,
      descripcion: descripcion
    });

    if (e.value !== "") {
      try {
        const resultUM = await function_ABM_ART_UnidadesMedida_Leer(e.value);

        if (resultUM?.data?.[0]) {
          setEsDivisible(!resultUM.data[0].EsBasica);
          setFactorDeConversion(resultUM.data[0].Cantidad);
        }
      } catch (error) {
        alert("Error al leer la unidad de medida:" + error);
      }
    }
  }

  const handleOnClick_AgregarUnidadMedida = async (e) => {
    if (!UnidadMedidaSeleccionada.codigo) {
      alert("Seleccione una Unidad de Medida antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const UnidadMedidaYaExiste = datos.ListArticulosUnidadesMedida?.some(
      (UnidadMedida) => UnidadMedida.ABM_ART_UnidadesMedida_CodigoUnidadMedida === UnidadMedidaSeleccionada.codigo
    );

    if (UnidadMedidaYaExiste) {
      alert("La Unidad de Medida ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaUnidadMedida = {
      ABM_ART_UnidadesMedida_CodigoUnidadMedida: UnidadMedidaSeleccionada.codigo,
      CodigoUnidadMedida: UnidadMedidaSeleccionada.codigo,
      Descripcion: UnidadMedidaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: "",
      EsDivisible: esDivisible ?? false,
      FactorDeConversion: factorDeConversion,
      EsSoloParaVentas: esSoloParaVentas ?? false,
      EsSoloParaCompras: esSoloParaCompras ?? false
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListArticulosUnidadesMedida: [...(prevDatos.ListArticulosUnidadesMedida || []), nuevaUnidadMedida],
    }));

    // Limpiar la selección después de agregar
    setUnidadMedidaSeleccionada(null);
  }

  const handleOnClick_AgregarPlanta = async (e) => {
    if (!plantaSeleccionada.codigo) {
      alert("Seleccione una Planta antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const plantaYaExiste = datos.ListPlantas?.some(
      (planta) => planta.ABM_ZON_Plantas_CodigoPlanta === plantaSeleccionada.codigo
    );

    if (plantaYaExiste) {
      alert("La Planta ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaPlanta = {
      ABM_ZON_Plantas_CodigoPlanta: plantaSeleccionada.codigo,
      CodigoPlanta: plantaSeleccionada.codigo,
      Descripcion: plantaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListPlantas: [...(prevDatos.ListPlantas || []), nuevaPlanta],
    }));

    // Limpiar la selección después de agregar
    setPlantaSeleccionada(null);
  }

  const handleOnClick_AgregarEmpresa = async (e) => {
    if (!empresaSeleccionada.codigo) {
      alert("Seleccione una Empresa antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const empresaYaExiste = datos.ListEmpresas?.some(
      (empresa) => empresa.ABM_ZON_Empresas_CodigoEmpresa === empresaSeleccionada.codigo
    );

    if (empresaYaExiste) {
      alert("La Empresa ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaEmpresa = {
      ABM_ZON_Empresas_CodigoEmpresa: empresaSeleccionada.codigo,
      CodigoEmpresa: empresaSeleccionada.codigo,
      Descripcion: empresaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListEmpresas: [...(prevDatos.ListEmpresas || []), nuevaEmpresa],
    }));

    // Limpiar la selección después de agregar
    setEmpresaSeleccionada(null);
  }

  const handleOnClick_Guardar = async (e) => {
    try {

      const JSON = await function_ABM_ART_Articulos_Generar_JSON(
        datos.CodigoArticulo,
        datos.CodigoBarras,
        datos.CodigoAlfa1,
        datos.CodigoAlfa2,
        datos.CodigoAlfa3,
        datos.CodigoNumerico1,
        datos.CodigoNumerico2,
        datos.CodigoNumerico3,
        datos.DescripcionCorta,
        datos.Descripcion,
        datos.CodigoSubtipoCompras,
        datos.CodigoSubtipoVentas,
        codigoUnidadMedidaMinima,
        datos.Vendible,
        datos.Comprable,
        datos.Fabricable,
        datos.Stockeable,
        datos.Servicio,
        datos.SubeStockEnRecepcion,
        datos.BajaStockEnRemito,
        datos.Oferta,
        datos.FechaVigenciaWebDesde,
        datos.FechaVigenciaWebHasta,
        datos.Link,
        datos.MultiPlanta,
        datos.MultiEmpresa,
        datos.CodigoCuentaContableCompra,
        datos.CodigoCuentaContableVenta,
        datos.CodigoSubCCCompra,
        datos.CodigoSubCCVenta,
        datos.ImporteSugeridoVenta,
        datos.ImporteSugeridoCompra,
        datos.PorcentajeIVA,
        datos.BajaStockDeOtroArticulo,
        datos.BajaStockCodigoArticulo,
        datos.CodigoBarrasInt,
        datos.CodigoBarrasProveedor,
        datos.Fantasma,
        datos.CMVPorcentajePretendido,
        datos.PorcentajeImpuestosInternos,
        datos.PorcentajeComisionAVendedores,
        datos.PorcentajeComisionAVendedores2,
        datos.Agrupador,
        datos.PorcentajeUtilidad,
        datos.PorcentajeUtilidadWeb,
        datos.PorcentajeUtilidadMinimoWeb,
        datos.ImporteSugeridoVentaWeb,
        datos.ImporteSugeridoVentaMinimoWeb,
        datos.Reservable,
        datos.ValorEnPuntos,
        datos.Seriado,
        datos.SeriadoObligatorio,
        datos.ImporteSugeridoVentaEsImporteFinal,
        datos.ImporteSugeridoVentaNoSeActualiza,
        datos.ListArticulosPresentaciones,
        datos.ListArticulosTamanos,
        datos.ListArticulosUnidadesMedida,
        datos.ListPlantas,
        datos.ListEmpresas,
      )

      console.log(JSON)

      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_ART_Articulos_Insertar(JSON, false)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_ART_Articulos_Modificar(JSON, false)

        alert("Se ha modificado el Código: " + datos.CodigoArticulo)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  const validateForm = (e) => {
    e.component.validate();
  };

  useEffect(() => {
    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            CodigoArticulo: '',
            CodigoBarras: '',
            CodigoAlfa1: '',
            CodigoAlfa2: '',
            CodigoAlfa3: '',
            CodigoNumerico1: 0,
            CodigoNumerico2: 0,
            CodigoNumerico3: 0,
            DescripcionCorta: '',
            Descripcion: '',
            CodigoSubtipoCompras: '',
            CodigoSubtipoVentas: '',
            CodigoUnidadMedidaMinima: '',
            Vendible: false,
            Comprable: false,
            Fabricable: false,
            Stockeable: false,
            Servicio: false,
            SubeStockEnRecepcion: true,
            BajaStockEnRemito: true,
            Oferta: false,
            FechaVigenciaWebDesde: null,
            FechaVigenciaWebHasta: null,
            Link: '',
            MultiPlanta: true,
            MultiEmpresa: true,
            CodigoCuentaContableCompra: '',
            CodigoCuentaContableVenta: '',
            CodigoSubCCCompra: '',
            CodigoSubCCVenta: '',
            ImporteSugeridoVenta: 0.0,
            ImporteSugeridoCompra: 0.0,
            PorcentajeIVA: 0.0,
            BajaStockDeOtroArticulo: false,
            BajaStockCodigoArticulo: '',
            CodigoBarrasInt: '',
            CodigoBarrasProveedor: '',
            Fantasma: false,
            CMVPorcentajePretendido: 0.0,
            PorcentajeImpuestosInternos: 0.0,
            PorcentajeComisionAVendedores: 0.0,
            PorcentajeComisionAVendedores2: 0.0,
            Agrupador: false,
            PorcentajeUtilidad: 0.0,
            PorcentajeUtilidadWeb: 0.0,
            PorcentajeUtilidadMinimoWeb: 0.0,
            ImporteSugeridoVentaWeb: 0.0,
            ImporteSugeridoVentaMinimoWeb: 0.0,
            Reservable: false,
            ValorEnPuntos: 0,
            Seriado: false,
            SeriadoObligatorio: false,
            ImporteSugeridoVentaEsImporteFinal: false,
            ImporteSugeridoVentaNoSeActualiza: false,
            ConsumeStockDeOtroArticulo: false
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_ART_Articulos_Leer(props.Codigo.Codigo)
          setDatos(datosDocumento.data[0])

          setEsMultiPlanta(datosDocumento.data[0].MultiPlanta)
          setEsMultiEmpresa(datosDocumento.data[0].MultiEmpresa)

          setValorCodigoSubtipoCompras(datosDocumento.data[0].CodigoSubtipoCompras)
          setValorCodigoSubtipoVentas(datosDocumento.data[0].CodigoSubtipoVentas)
          setValorCodigoSubCCVenta(datosDocumento.data[0].CodigoSubCCVenta)
          setValorCodigoSubCCCompra(datosDocumento.data[0].CodigoSubCCCompra)
          setValorCodigoCuentaContableVenta(datosDocumento.data[0].CodigoCuentaContableVenta)
          setValorCodigoCuentaContableCompra(datosDocumento.data[0].CodigoCuentaContableCompra)
          setValorCodigoArticuloConsumeStockDeOtroArticulo(datosDocumento.data[0].CodigoArticuloConsumeStockDeOtroArticulo)
          setCodigoUnidadMedidaMinima(datosDocumento.data[0].codigoUnidadMedidaMinima)
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <TabbedItem>
        <TabPanelOptions deferRendering={false} />

        <Tab title="General" colCount={2}>
          <GroupItem caption="General">
            <SimpleItem dataField="CodigoArticulo" >
              <Label text="Código" />
              <RequiredRule message="Indicar el Código es obligatorio." />
            </SimpleItem>
            <SimpleItem dataField="Descripcion">
              <Label text="Descripción Corta" />
              <RequiredRule message="Indicar la Descripción es obligatorio." />
            </SimpleItem>
            <SimpleItem dataField="DescripcionLarga" helpText="Esta Descripción puede ser igual a la anterior.">
              <Label text="Descripción Larga" />
              <RequiredRule message="Indicar la Descripción Larga es obligatorio." />
            </SimpleItem>
            <SimpleItem>
              <Label text="Unidad de Medida Mínima" />
              <ComboAbmArtUnidadesMedida
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={codigoUnidadMedidaMinima}
                onValueChanged={(e) => setCodigoUnidadMedidaMinima(e.value)} />
            </SimpleItem>

            <GroupItem caption="Clasificación" colCount={1}>
              <SimpleItem>
                <Label text="Subtipo de Compras" />
                <ComboAbmArtSubTiposCompra
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={valorCodigoSubtipoCompras}
                  onValueChanged={handleOnValueChangedCodigoSubtipoCompras} />
              </SimpleItem>

              <SimpleItem>
                <Label text="Subtipo de Ventas" />
                <ComboAbmArtSubTiposVenta
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={valorCodigoSubtipoVentas}
                  onValueChanged={onValueChangedCodigoSubtipoVentas} />
              </SimpleItem>

              <SimpleItem>
                <Label text="Subcentro de Costos Compras" />
                <ComboAbmConSubCentrosCosto
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={valorCodigoSubCCCompra}
                  onValueChanged={onValueChangedCodigoSubCentroCostoCompras} />
              </SimpleItem>

              <SimpleItem>
                <Label text="Subcentro de Costos Ventas" />
                <ComboAbmConSubCentrosCosto
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={valorCodigoSubCCVenta}
                  onValueChanged={onValueChangedCodigoSubCentroCostoVentas} />
              </SimpleItem>

              <SimpleItem>
                <Label text="Cuenta Contable Compras" />
                <ComboAbmConCuentasContable
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={valorCodigoCuentaContableCompra}
                  onValueChanged={onValueChangedCodigoCuentaContableCompras} />
              </SimpleItem>

              <SimpleItem>
                <Label text="Cuenta Contable Ventas" />
                <ComboAbmConCuentasContable
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={valorCodigoCuentaContableVenta}
                  onValueChanged={onValueChangedCodigoCuentaContableVentas} />
              </SimpleItem>
            </GroupItem>
          </GroupItem>

          <GroupItem caption="Parámetros">
            <GroupItem caption="Tipo" colCount={2}>
              <SimpleItem dataField="Comprable" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedComprable(e) }}>
                <Label text="Comprable" />
              </SimpleItem>
              <SimpleItem dataField="Vendible" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedVendible(e) }}>
                <Label text="Vendible" />
              </SimpleItem>
              <SimpleItem dataField="Fabricable" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedFabricable(e) }}>
                <Label text="Fabricable" />
              </SimpleItem>
              <SimpleItem dataField="Servicio" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedServicio(e) }}>
                <Label text="Servicio" />
              </SimpleItem>
              <SimpleItem dataField="Reservable" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedReservable(e) }}>
                <Label text="Reservable" />
              </SimpleItem>
              <SimpleItem dataField="Agrupador" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedAgrupador(e) }}>
                <Label text="Agrupador" />
              </SimpleItem>
              <SimpleItem dataField="Fantasma" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedFantasma(e) }}>
                <Label text="Fantasma" />
              </SimpleItem>
              <SimpleItem dataField="Oferta" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedOferta(e) }}>
                <Label text="Oferta" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Stock">
              <SimpleItem dataField="Stockeable" editorType="dxCheckBox" value="false"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedStockeable(e) }}>
                <Label text="Stockeable" />
              </SimpleItem>
              <SimpleItem dataField="BajaStockEnRemito" editorType="dxCheckBox" visible={datos.Stockeable}
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedBajaStockEnRemito(e) }}>
                <Label text="Baja Stock en Remito" />
              </SimpleItem>
              <SimpleItem dataField="SubeStockEnRecepcion" editorType="dxCheckBox" visible={datos.Stockeable}
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedSubeStockEnRecepcion(e) }}>
                <Label text="Sube Stock en Recepción" />
              </SimpleItem>
              <SimpleItem dataField="ConsumeStockDeOtroArticulo" editorType="dxCheckBox" visible={datos.Stockeable}
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedConsumeStockDeOtroArticulo(e) }}>
                <Label text="Consume Stock de otro Artículo" />
              </SimpleItem>
              <SimpleItem visible={datos.ConsumeStockDeOtroArticulo}>
                <Label text="Artículo" />
                <ComboAbmArtArticulos
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={valorCodigoArticuloConsumeStockDeOtroArticulo} 
                  ancho={300}
                  onValueChanged={onValueChangedCodigoArticuloConsumeStockDeOtroArticulo} />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Seriado">
              <SimpleItem dataField="Seriado" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedSeriado(e) }}>
                <Label text="Seriado" />
              </SimpleItem>
              <SimpleItem dataField="SeriadoObligatorio" editorType="dxCheckBox" visible={datos.Seriado}
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedSeriadoObligatorio(e) }}>
                <Label text="Seriado Obligatorio" />
              </SimpleItem>
              <SimpleItem dataField="NumeroDeSerie" visible={datos.Seriado}>
                <Label text="Número de Serie" />
              </SimpleItem>
            </GroupItem>
          </GroupItem>
        </Tab>

        <Tab title="Códigos">
          <GroupItem caption="Barras">
            <SimpleItem dataField="CodigoBarras" >
              <Label text="Código" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Alfanúmericos">
            <SimpleItem dataField="CodigoAlfa1">
              <Label text="Código 1" />
            </SimpleItem>
            <SimpleItem dataField="CodigoAlfa2">
              <Label text="Código 2" />
            </SimpleItem>
            <SimpleItem dataField="CodigoAlfa3">
              <Label text="Código 3" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Númericos">
            <SimpleItem dataField="CodigoNumerico1">
              <Label text="Código 1" />
            </SimpleItem>
            <SimpleItem dataField="CodigoNumerico2">
              <Label text="Código 2" />
            </SimpleItem>
            <SimpleItem dataField="CodigoNumerico3">
              <Label text="Código 3" />
            </SimpleItem>
          </GroupItem>
        </Tab>

        <Tab title="Importes">
          <GroupItem caption="Importes y Porcentajes" colCount={2} >
            <GroupItem caption="Porcentajes">
              <SimpleItem dataField="PorcentajeIVA" >
                <Label text="Porcentaje I.V.A. (%)" />
              </SimpleItem>
              <SimpleItem dataField="PorcentajeImpuestosInternos" >
                <Label text="Porcentaje Impuestos Internos (%)" />
              </SimpleItem>
              <SimpleItem dataField="Utilidad" >
                <Label text="Utilidad (%)" />
              </SimpleItem>
              <SimpleItem dataField="UtilidadWeb" >
                <Label text="Utilidad WEB (%)" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Importes">
              <SimpleItem dataField="ImporteSugeridoVenta" >
                <Label text="Importe Sugerido de Venta" />
              </SimpleItem>
              <SimpleItem dataField="ImporteSugeridoVentaWeb" >
                <Label text="Importe Sugerido de Venta WEB" />
              </SimpleItem>
              <SimpleItem dataField="ImporteSugeridoCompra" >
                <Label text="Importe Sugerido de Compra (Neto en U.M. Básica)" />
              </SimpleItem>
              <SimpleItem dataField="ImporteSugeridoDeVentaEsImporteFinal" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedImporteSugeridoDeVentaEsImporteFinal(e) }}>
                <Label text="Importe Sugerido de Venta es Importe Final (si es NO se aplicará I.V.A.)" />
              </SimpleItem>
              <SimpleItem dataField="ImporteSugeridoDeVentaNoSeActualizaAutomaticamente" editorType="dxCheckBox"
                editorOptions={{ onValueChanged: (e) => handleOnValueChangedImporteSugeridoDeVentaNoSeActualizaAutomaticamente(e) }}>
                <Label text="Importe Sugerido de Venta NO se actualiza automáticamente" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Comisiones">
              <SimpleItem dataField="PorcentajeComisionVendedores1" >
                <Label text="Porcentaje de Comisión a Vendedores 1 (%)" />
              </SimpleItem>
              <SimpleItem dataField="PorcentajeComisionVendedores2" >
                <Label text="Porcentaje de Comisión a Vendedores 2 (%)" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Puntajes">
              <SimpleItem dataField="Puntos" >
                <Label text="Valor en Puntos" />
              </SimpleItem>
            </GroupItem>
          </GroupItem>
        </Tab>

        <Tab title="Dimensiones" colCount={2}>
          <GroupItem caption="Tamaño" colCount={1} >
            <SimpleItem dataField="Largo" >
              <Label text="Largo" />
            </SimpleItem>
            <SimpleItem dataField="Ancho" >
              <Label text="Ancho" />
            </SimpleItem>
            <SimpleItem dataField="Alto" >
              <Label text="Alto" />
            </SimpleItem>
          </GroupItem>
          <GroupItem caption="Peso" colCount={1} >
            <SimpleItem dataField="Peso" >
              <Label text="Peso" />
            </SimpleItem>
            <SimpleItem dataField="TaraEnvase" >
              <Label text="Tara del Envase" />
            </SimpleItem>
          </GroupItem>
        </Tab>

        <Tab title="Tamaños">
          <GroupItem>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmArtTamanos
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component?.option("text") || "";
                  setTamanoSeleccionado({
                    codigo: e.value,
                    descripcion: descripcion
                  });
                }} />
              <LVButtonAccion Texto={"AGREGAR TAMAÑO"} onClick={handleOnClick_AgregarTamano} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListArticulosTamanos}
              keyExpr="CodigoTamano"
            >
              <Column caption="Código" dataField="CodigoTamano" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Presentaciones">
          <GroupItem>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmArtPresentaciones
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component?.option("text") || "";
                  setPresentacionSeleccionada({
                    codigo: e.value,
                    descripcion: descripcion
                  });
                }} />
              <LVButtonAccion Texto={"AGREGAR PRESENTACIÓN"} onClick={handleOnClick_AgregarPresentacion} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListArticulosPresentaciones}
              keyExpr="ABM_ART_Presentaciones_CodigoPresentacion"
            >
              <Column caption="Código" dataField="ABM_ART_Presentaciones_CodigoPresentacion" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Unidades de Medida">
          <GroupItem>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px', gap: '10px' }}>
              <ComboAbmArtUnidadesMedida
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={handleOnValueChanged_UnidadMedida} />

              Factor de Conversión
              <TextBox value={factorDeConversion} width={50} />
              <CheckBox text="Solo Ventas" value={esSoloParaVentas ?? false} onValueChange={(e) => setEsSoloParaVentas(e)} />
              <CheckBox text="Solo Compras" value={esSoloParaCompras ?? false} onValueChange={(e) => setEsSoloParaCompras(e)} />
              <LVButtonAccion Texto={"AGREGAR UNIDAD DE MEDIDA"} onClick={handleOnClick_AgregarUnidadMedida} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListArticulosUnidadesMedida}
              keyExpr="ABM_ART_UnidadesMedida_CodigoUnidadMedida"
            >
              <Column caption="Código" dataField="ABM_ART_UnidadesMedida_CodigoUnidadMedida" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />

              <Column caption="Factor de Conversión" dataField="FactorDeConversion" width="170" alignment="Right" dataType="number" />
              <Column caption="Solo Ventas" dataField="EsSoloParaVentas" width="100" alignment="Center" dataType="boolean" />
              <Column caption="Solo Compras" dataField="EsSoloParaCompras" width="120" alignment="Center" dataType="boolean" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Plantas">
          <GroupItem>
            <SimpleItem dataField="MultiPlanta" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiPlanta(e) }}>
              <Label text="MultiPlanta (Desactivado permite definir para que Plantas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiPlanta}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonPlantas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setPlantaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR PLANTA"} onClick={handleOnClick_AgregarPlanta} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListPlantas}
              keyExpr="ABM_ZON_Plantas_CodigoPlanta"
            >
              <Column caption="Código" dataField="ABM_ZON_Plantas_CodigoPlanta" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Empresas">
          <GroupItem>
            <SimpleItem dataField="MultiEmpresa" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiEmpresa(e) }}>
              <Label text="MultiEmpresa (Desactivado permite definir para que Empresas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiEmpresa}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonEmpresas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setEmpresaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR EMPRESA"} onClick={handleOnClick_AgregarEmpresa} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListEmpresas}
              keyExpr="ABM_ZON_Empresas_CodigoEmpresa"
            >
              <Column caption="Código" dataField="ABM_ZON_Empresas_CodigoEmpresa" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>
      </TabbedItem>

      <ButtonItem horizontalAlignment="Center">
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_ART_Articulos;